import { Button } from "@pma/components/common/button"
import { Input } from "@pma/components/common/input"
import useTranslator from "@pma/hooks/use-translator"
import { cn } from "@pma/utils/helpers"
import * as React from "react"
import { SubmitHandler, useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import * as z from "zod"
import { GroupedTasksContext } from "./context/GroupedTasksProvider"
import { IGroupInput } from "./api-fns"
import { useParams } from "react-router-dom"

export interface IAddGroupProps { }
interface IFormInputs {
  group_name: string
}

const schema = z.object({
  group_name: z.string().trim().min(1, "This field is required."),
})

export function AddGroup(props: IAddGroupProps) {
  const { translate } = useTranslator()
  const { projectId } = useParams()
  const { createGroupMutation, groupedTasksRefetch } = React.useContext(GroupedTasksContext)
  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isSubmitting },
    reset,
  } = useForm<IFormInputs>({
    resolver: zodResolver(schema),
  })

  const onSubmit: SubmitHandler<IFormInputs> = (data) => {
    if (!projectId) return
    const payload: IGroupInput = {
      ...data,
      project_id: parseInt(projectId),
    }
    createGroupMutation?.mutate(payload)
  }

  React.useEffect(() => {
    if (!createGroupMutation?.isPending && createGroupMutation?.isSuccess) {
      groupedTasksRefetch()
      reset()
    }
  }, [createGroupMutation?.isPending])

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='flex flex-wrap w-full gap-2 sm:flex-nowrap mb-2 xl:mb-0'>
      <Input
        placeholder={translate("New Group")}
        className='h-8 w-full'
        {...register("group_name", { required: true })}
      />
      <Button
        size={"sm"}
        loading={createGroupMutation?.isPending || isSubmitting}
        disabled={createGroupMutation?.isPending || !isValid}
        type='submit'
        className="w-full sm:w-auto"
      >
        {translate("Add Group")}
      </Button>
    </form>
  )
}
